// components/Common/LoadingSpinner.js - Компонент загрузки

import React from 'react';
import '../../styles/Common.css';

/**
 * Компонент спиннера загрузки
 */
const LoadingSpinner = ({ 
  size = 'medium', 
  message = 'Загрузка...', 
  showMessage = true,
  fullScreen = false,
  color = 'primary'
}) => {
  // Определяем размеры спиннера
  const getSizeClass = () => {
    switch (size) {
      case 'small': return 'loading-spinner-small';
      case 'large': return 'loading-spinner-large';
      case 'xlarge': return 'loading-spinner-xlarge';
      default: return 'loading-spinner-medium';
    }
  };
  
  // Определяем цвет спиннера
  const getColorClass = () => {
    switch (color) {
      case 'secondary': return 'loading-spinner-secondary';
      case 'success': return 'loading-spinner-success';
      case 'warning': return 'loading-spinner-warning';
      case 'danger': return 'loading-spinner-danger';
      default: return 'loading-spinner-primary';
    }
  };
  
  const spinnerContent = (
    <div className="loading-spinner-content">
      <div className={`loading-spinner ${getSizeClass()} ${getColorClass()}`}>
        <div className="spinner-ring"></div>
        <div className="spinner-ring"></div>
        <div className="spinner-ring"></div>
        <div className="spinner-ring"></div>
      </div>
      {showMessage && message && (
        <div className="loading-message">
          {message}
        </div>
      )}
    </div>
  );
  
  if (fullScreen) {
    return (
      <div className="loading-overlay">
        {spinnerContent}
      </div>
    );
  }
  
  return (
    <div className="loading-container">
      {spinnerContent}
    </div>
  );
};

/**
 * Компонент точек загрузки (альтернативный стиль)
 */
export const LoadingDots = ({ message = 'Загрузка', color = 'primary' }) => {
  return (
    <div className="loading-dots-container">
      <div className={`loading-dots loading-dots-${color}`}>
        <div className="dot"></div>
        <div className="dot"></div>
        <div className="dot"></div>
      </div>
      {message && (
        <div className="loading-message">
          {message}
        </div>
      )}
    </div>
  );
};

/**
 * Компонент полосы загрузки
 */
export const LoadingBar = ({ 
  progress = 0, 
  showPercentage = false, 
  animated = true,
  color = 'primary' 
}) => {
  return (
    <div className="loading-bar-container">
      <div className={`loading-bar loading-bar-${color}`}>
        <div 
          className={`loading-bar-fill ${animated ? 'loading-bar-animated' : ''}`}
          style={{ width: `${Math.min(100, Math.max(0, progress))}%` }}
        />
      </div>
      {showPercentage && (
        <div className="loading-percentage">
          {Math.round(progress)}%
        </div>
      )}
    </div>
  );
};

/**
 * Компонент скелетона загрузки
 */
export const LoadingSkeleton = ({ 
  lines = 3, 
  width = '100%', 
  height = '1rem',
}) => {
  return (
    <div>
      {Array.from({ length: lines }, (_, index) => (
        <div 
          key={index}
          className="skeleton-line"
          style={{ 
            width: Array.isArray(width) ? width[index] || '100%' : width,
            height: Array.isArray(height) ? height[index] || '1rem' : height
          }}
        />
      ))}
    </div>
  );
};

export default LoadingSpinner;